module.exports = __webpack_public_path__ + "img/secure_pwd.4c91e5e0.svg";